<button
  class="inline-flex h-10 w-full items-center justify-start bg-white hover:bg-neutral-50"
  [class.bg-neutral-100]="selected()"
  [attr.aria-checked]="selected()"
  (click)="onClick($event)"
  (keydown.enter)="onClick($event)"
  (keydown.space)="onClick($event); $event.preventDefault()"
  tabindex="0"
  role="checkbox"
>
  <div class="flex w-full items-center gap-3 py-2">
    <div class="ml-5 flex-shrink-0">
      <div
        class="flex h-5 w-5 items-center justify-center rounded-none border"
        [class.border-neutral-900]="true"
        [class.bg-neutral-900]="selected()"
        [class.bg-white]="!selected()"
      >
        @if (selected()) {
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 6L9 17L4 12"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        }
      </div>
    </div>
    <div
      class="mr-5 truncate text-left text-base leading-normal font-normal text-primary-text"
    >
      {{ name() }}
    </div>
  </div>
</button>
